<template>

    <div class="accounts-page admin-page">
        <Header></Header>
        <vue-ins-progress-bar></vue-ins-progress-bar>
        <section class="accounts-section" :data-profileId="profileId">
            <div class="container">
                <div class="row admin-bar">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <router-link class="next-icon prev-b" to="/admin/artists"><img src="@/assets/img/prev.svg"/> Artist List</router-link>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <span>Welcome back, Susan!</span>
                        <h2>Fill out your account details</h2>
                        <form class="form" v-on:submit.prevent="accountsFormSubmit" enctype="multipart/form-data">
                            <div class="input-file-field form-input">
                                <p>Profile Image</p>
                                <label for="profile-image">
                                    <span>{{profileImageName}}</span>
                                    <span>Choose File</span>
                                </label>
                                <input type="file" id="profile-image" ref="profileImageFile" v-on:change="handleProfileImageUpload">
                            </div>
                            <div class="input-file-field form-input">
                                <p>Background Image</p>
                                <label for="bg-image">
                                    <span>{{bgImageName}}</span>
                                    <span>Choose File</span>
                                </label>
                                <input type="file" id="bg-image" ref="bgImageFile" v-on:change="handleBgImageUpload">
                            </div>
                            <div class="input-select-field form-input">
                                <label for="your-profession">Profession * <span></span></label>
                                <select id="your-profession" v-model="profession"  v-on:change="yourProfession(profession)">
                                    <option value="">Select Profession</option>
                                    <option value="Dancer">Dancer</option>
                                    <option value="Musician">Musician</option>
                                    <option value="Visual Artist">Visual Artist</option>
                                    <option value="Cinematographer">Cinematographer</option>
                                    <option value="Other">Other</option>
                                </select>
                                <p class="error-input" v-if="professionFlag">Profession is required</p>
                            </div>
                            <div class="input-tags-field form-input">
                                <label>Skills *</label>
                                <tags-input element-id="tags"
                                            v-model="selectedSkills"
                                            :only-existing-tags="true"
                                            :delete-on-backspace="true"
                                            :typeahead-hide-discard="true"
                                            placeholder="Add your skills"
                                            @tags-updated="skillsFuntion"
                                            :existing-tags="$options.skills"
                                            :typeahead="true"></tags-input>
                                <p class="error-input" v-if="skillsFlag">Skills are required</p>
                            </div>
                            <!--<div class="input-field form-input">-->
                                <!--<label for="your-location">Location *</label>-->
                                <!--<input type="text" placeholder="Your City" id="your-location" v-model="location"-->
                                       <!--v-on:blur="yourLocation(location)">-->
                                <!--<p class="error-input" v-if="locationFlag">Location is required</p>-->
                            <!--</div>-->
                            <div class="input-select-field form-input country-list">
                                <!--<label for="your-tag">Country *<span></span></label>-->
                                <!--<select id="your-tag" v-model="country" v-on:change="getCities">-->
                                    <!--<option value="">Select Country</option>-->
                                    <!--<option :value="index" v-for="(data, index) in $options.myJson">{{index}}</option>-->
                                <!--</select>-->
                                <label>Country</label>
                                <v-select :options="$options.myJson" v-model="country" />
                            </div>
                            <div class="input-select-field form-input">
                                <label>City</label>
                                <v-select :options="citiesList" v-model="city" />
                                <!--<label for="your-tag">City *<span></span></label>-->
                                <!--<select id="your-tag1" v-model="location">-->
                                    <!--<option value="">Select City</option>-->
                                    <!--<option :value="data" v-for="(data, index) in citiesList">{{data}}</option>-->
                                <!--</select>-->
                                <!--<p class="error-input" v-if="locationFlag">Location is required</p>-->
                            </div>
                            <div class="input-field form-input account-contact-fields">
                                <label for="your-contact">Contact *</label>
                                <input type="text" placeholder="Twitter" id="your-contact" v-model="twitterContact" v-on:blur="twitterContactFuntion(twitterContact)">
                                <p class="error-input" v-if="twitterContactFlag">Twitter is required</p>
                                <input type="text" placeholder="Facebook" v-model="facebookContact" v-on:blur="facebookContactFuntion(facebookContact)">
                                <p class="error-input" v-if="facebookContactFlag">Facebook is required</p>
                                <input type="text" placeholder="Instagram" v-model="instagramContact" v-on:blur="instagramContactFuntion(instagramContact)">
                                <p class="error-input" v-if="instagramContactFlag">Instagram is required</p>
                                <input type="text" placeholder="You Tube" v-model="youtubeContact" v-on:blur="youtubeContactFuntion(youtubeContact)">
                                <p class="error-input" v-if="youtubeContactFlag">YouTube is required</p>
                                <input type="text" placeholder="website link" v-model="websiteContact">
                                <input type="text" placeholder="Email Id" v-model="emailIdContact">
                            </div>
                            <div class="input-field form-input account-contact-fields">
                                <label for="your-education">Higher Education</label>
                                <input type="text" placeholder="Higher Education College" id="your-education" v-model="college">
                                <input type="text" placeholder="Degree" v-model="degree">
                                <input type="text" placeholder="Graduation Year" v-model="passoutyear">
                            </div>
                            <div class="input-textarea-field form-input">
                                <label for="your-bio">Bio *</label>
                                <textarea placeholder="Something about you..." id="your-bio" v-model="bio" v-on:blur="bioFuntion(bio)"></textarea>
                                <p class="error-input" v-if="bioFlag">Bio is required</p>
                            </div>
                            <div class="input-field form-input">
                                <label for="isfeatured">Is Featured</label>
                                <input type="checkbox" v-model="isfeatured" id="isfeatured">
                            </div>
                            <div class="input-submit">
                                <input type="hidden" :value="profileId"/>
                                <input type="hidden" :value="imageId"/>
                                <button type="submit" v-if="!submitOnce">FINISH ACCOUNT SETUP</button>
                                <a href="javascript:void(0)" v-if="submitOnce">SUBMIT...</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <Footer></Footer>
    </div>
</template>

<style>
    @import "../../../assets/css/tagsinput.css";
</style>

<script>
    import $ from "jquery"
    import Header from '../Header'
    import Footer from '../Footer'
    import Vue from 'vue'
    import VueInsProgressBar from 'vue-ins-progress-bar'
    import axios from 'axios'
    import VoerroTagsInput from '@voerro/vue-tagsinput'
    import router from '../../../router'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    import contries from '@/assets/country.json'
    import cities from '@/assets/cities.json'
    import skills from '@/assets/skills.json'
    Vue.use(VueToast)
    import vSelect from "vue-select";
    Vue.component("v-select", vSelect);
    import "vue-select/dist/vue-select.css";
    const options = {
        position: 'fixed',
        show: true,
        height: '5px'
    }
    Vue.use(VueInsProgressBar, options)

    export default {
        name: 'ProfileEdit',
        myJson: contries,
        myJsonCities: cities,
        skills: skills,
        components: {
            'Header': Header,
            'Footer': Footer,
            'tags-input': VoerroTagsInput
        },
        data() {
            var userdata = localStorage.getItem('cbs_admin_usertoken')
            if(userdata){
                userdata = JSON.parse(userdata)
            }

            return {
                location: '',
                locationFlag: false,
                isfeatured: false,
                profession: '',
                professionFlag: false,
                twitterContact: '',
                userData: userdata,
                twitterContactFlag: false,
                facebookContact: '',
                facebookContactFlag: false,
                instagramContact: '',
                instagramContactFlag: false,
                youtubeContact: '',
                websiteContact: '',
                emailIdContact: '',
                youtubeContactFlag: false,
                bio: '',
                college: '',
                degree: '',
                passoutyear: '',
                bioFlag: false,
                bgImageName: 'Select Image',
                profileImageName: 'Select Image',
                userId: router.history.current.params.userId,
                profileId: '',
                submitOnce: false,
                profile: '',
                imageId: '',
                selectedSkills: [],
                skillsFlag: false,
                country: '',
                tags: [],
                city: '',
                citiesList: ["Please select country first"],
                msg: 'Welcome to Your Vue.js App'
            }
        },
        mounted () {
            let $this = this
            $('.country-list .vs__search').blur(function (event) {
                setTimeout(function () {
                    $this.getCities()
                }, 300)
            });
            axios
                .get('/getprofile', {
                    params: {
                        userId: this.userId
                    }
                })
                .then(response => {
                    this.profileId = response.data.profiles[0]._id
                    this.country = response.data.profiles[0].country
                    this.citiesList = this.$options.myJson[this.country]
                    this.city = response.data.profiles[0].location
                    this.profession = response.data.profiles[0].profession
                    this.selectedSkills = response.data.profiles[0].skills
                    this.isfeatured = response.data.profiles[0].isfeatured
                    this.twitterContact = response.data.profiles[0].twitterContact
                    this.facebookContact = response.data.profiles[0].facebookContact
                    this.instagramContact = response.data.profiles[0].instagramContact
                    this.websiteContact = response.data.profiles[0].websiteContact
                    this.emailIdContact = response.data.profiles[0].emailIdContact
                    this.youtubeContact = response.data.profiles[0].youtubeContact
                    this.college = response.data.profiles[0].college
                    this.degree = response.data.profiles[0].degree
                    this.passoutyear = response.data.profiles[0].passoutyear
                    this.bio = response.data.profiles[0].bio
                    this.profileImageName = response.data.profiles[0].images[0].profileImageName
                    this.bgImageName = response.data.profiles[0].images[0].bgImageName
                    this.imageId = response.data.profiles[0].images[0]._id
                    if(response.data.profiles[0].skills){
                        var list = []
                        response.data.profiles[0].skills.map(function(value, key) {
                            list.push({key: value, value: value})
                        })
                    }
                    this.selectedSkills = list
                    var tags = []
                    this.selectedSkills.map(function(value, key) {
                        tags.push(value.value)
                    })
                    this.tags = tags
                })
                .catch(error => console.log(error))
        },
        methods: {
            yourProfession: function (msg) {
                if (!msg) {
                    this.professionFlag = true
                } else {
                    this.professionFlag = false
                }
            },
            skillsFuntion(msg){
                if (!this.selectedSkills.length) {
                    this.skillsFlag = true
                } else {
                    this.skillsFlag = false
                    var tags = []
                    this.selectedSkills.map(function(value, key) {
                        tags.push(value.value)
                    })
                    this.tags = tags
                }
            },
            yourLocation: function (msg) {
                if (!msg) {
                    this.locationFlag = true
                } else {
                    this.locationFlag = false
                }
            },
            twitterContactFuntion: function (msg) {
                if (!msg) {
                    this.twitterContactFlag = true
                } else {
                    this.twitterContactFlag = false
                }
            },
            facebookContactFuntion: function (msg) {
                if (!msg) {
                    this.facebookContactFlag = true
                } else {
                    this.facebookContactFlag = false
                }
            },
            instagramContactFuntion: function (msg) {
                if (!msg) {
                    this.instagramContactFlag = true
                } else {
                    this.instagramContactFlag = false
                }
            },
            youtubeContactFuntion: function (msg) {
                if (!msg) {
                    this.youtubeContactFlag = true
                } else {
                    this.youtubeContactFlag = false
                }
            },
            bioFuntion: function (msg) {
                if (!msg) {
                    this.bioFlag = true
                } else {
                    this.bioFlag = false
                }
            },
            handleBgImageUpload(){
                this.bgImageFile = this.$refs.bgImageFile.files[0]
                this.bgImageName = this.$refs.bgImageFile.files[0].name
                console.log(this.$refs.bgImageFile.files[0].name)
            },
            handleProfileImageUpload(){
                this.profileImageFile = this.$refs.profileImageFile.files[0]
                this.profileImageName = this.$refs.profileImageFile.files[0].name
                console.log(this.$refs.profileImageFile.files[0].name)
            },
            profileUpload () {
                try {
                    axios.post('/editprofile', {
                        profession: this.profession,
                        skills: this.tags,
                        location: this.city,
                        country: this.country,
                        isfeatured: this.isfeatured,
                        twitterContact: this.twitterContact,
                        facebookContact: this.facebookContact,
                        instagramContact: this.instagramContact,
                        youtubeContact: this.youtubeContact,
                        websiteContact: this.websiteContact,
                        emailIdContact: this.emailIdContact,
                        college: this.college,
                        degree: this.degree,
                        passoutyear: this.passoutyear,
                        bio: this.bio,
                        imageId: this.imageId,
                        profileId: this.profileId
                    },{
                        headers: {
                            "content-type": "application/json",
                            "x-api-key": this.userData.token
                        }
                    }).then(res => {
                        console.log(res)
                        this.$insProgress.finish()
                        this.submitOnce = false
                        Vue.$toast.open(
                            {
                                message: 'Profile updated!',
                                type: 'success',
                                position: 'top-right'
                                // all other options
                            }
                        )
                    }).catch(err => {
                        console.log(err)
                    })
                } catch (e) {
                    console.log(e)
                }
            },
            getCities: function (event) {
                this.citiesList = this.$options.myJsonCities[this.country]
            },
            accountsFormSubmit: function (event) {
                this.submitOnce = true
                this.$insProgress.start()
                if(this.profileImageFile || this.bgImageFile){
                    const formData = new FormData()
                    if(this.profileImageFile){
                        formData.append('profileImageFile', this.profileImageFile)
                        formData.append('profileImageName', this.profileImageName)
                    }
                    if(this.bgImageFile){
                        formData.append('bgImageFile', this.bgImageFile)
                        formData.append('bgImageName', this.bgImageName)
                    }
                    formData.append('imageId', this.imageId)
                    try {
                        axios.post('/profileImageEdit', formData,{
                            headers: {
                                "content-type": "application/json",
                                "x-api-key": this.userData.token
                            }
                        }).then(res => {
                            this.profileUpload()
                            console.log(res)
                        }).catch(err => {
                            console.log(err)
                        })
                    } catch (e) {
                        console.log(e)
                    }
                } else {
                    this.profileUpload()
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/profiles/Edit.vue